<template>
  <red-envelope-modal class="plv-iar-red-envelope__questionnaire--limit" @close="$emit('close')">
    <div class="plv-iar-red-envelope__questionnaire--limit--bg">

      <div class="plv-iar-red-envelope__questionnaire--limit--title">{{ iarTrans('redEnvelope.unfortunately') }}</div>
      <div class="plv-iar-red-envelope__questionnaire--limit--p1">{{ iarTrans('redEnvelope.notEligibleTip1') }}</div>
      <div class="plv-iar-red-envelope__questionnaire--limit--p2">{{ iarTrans('redEnvelope.notEligibleTip2', {rightCount: redpacketResult.rightCount, correctAnswer: redpacketResult.correctAnswer}) }}</div>

      <div class="plv-iar-red-envelope__questionnaire--limit-btn" @click="$emit('close')">
        {{ iarTrans('redEnvelope.close') }}
      </div>
    </div>
  </red-envelope-modal>
</template>

<script>
import RedEnvelopeModal from './components/RedEnvelopeModal';
import mixin from './mixin';
export default {
  name: 'MobileRedEnvelopeQuestionnaireLimit',
  mixins: [mixin],
  components: {
    RedEnvelopeModal
  },
  props: {
    redpacketResult: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>

<style lang="scss">
.plv-iar-red-envelope__questionnaire--limit {
  .plv-iar-red-envelope__popup__close {
    position: relative;
    top: -30px;
  }
}
.plv-iar-red-envelope__questionnaire--limit--bg {
  position: relative;
  top: -30px;
  width: 270px;
  height: 268px;
  margin: 0 auto;
  background-image: url(./imgs/redpacket-limit-bg.png);
  background-size: 130%;
  background-position: center;
  font-size: 14px;
  color: #FCEEBC;
  text-align: center;
  padding-top: 48px;
  box-sizing: border-box;
  border-radius: 20px;
  .plv-iar-red-envelope__questionnaire--limit--title {
    font-size: 28px;
    margin-bottom: 18px;
  }
  .plv-iar-red-envelope__questionnaire--limit--p1 {
    font-size: 20px;
  }
  .plv-iar-red-envelope__questionnaire--limit--p2 {
    font-size: 12px;
    margin-top: 10px;
  }
  .plv-iar-red-envelope__questionnaire--limit-btn {
    font-size: 16px;
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    height: 48px;
    line-height: 48px;
    border-radius: 24px;
    color: #4A2206;
    background: linear-gradient(180deg, rgba(253, 219, 133, 0.3) 0%, rgba(254, 233, 170, 0.3) 19%, rgba(255, 243, 197, 0.3) 44%, rgba(254, 234, 172, 0.3) 65%, rgba(251, 197, 74, 0.3) 100%), linear-gradient(180deg, #FCE948 0%, #F39C19 100%);
  }
}
</style>
